import AsyncCreatableSelect from 'react-select/async-creatable';
import { AsyncCreatableSelectProps, AsyncCreatableSelectPropsToOmit, AsyncOption, BaseProps } from './types';
import { GroupBase, OptionsOrGroups } from 'react-select/dist/declarations/src/types';
import { useInnerComponentsClassNames } from './hooks';

type Props<T> = Omit<AsyncCreatableSelectProps<T>, AsyncCreatableSelectPropsToOmit> &
    BaseProps & {
        value?: AsyncOption<T> | AsyncOption<T>[];
        onChange: (value: AsyncOption<T> | readonly AsyncOption<T>[] | undefined) => void;
        loadOptions: (inputValue: string) => Promise<OptionsOrGroups<AsyncOption<T>, GroupBase<AsyncOption<T>>>>;
    };

const PolicyAsyncCreatableSelectField = <T,>({
    disabled = false,
    clearable = false,
    searchable = false,
    multi = false,
    backspaceRemoves = false,
    value,
    loadOptions,
    onChange,
    className = '',
    ...selectProps
}: Props<T>) => {
    const { innerComponentsClassNames } = useInnerComponentsClassNames<T>(className);

    const loadSelectOptions: AsyncCreatableSelectProps<T>['loadOptions'] = async (inputValue = '', callback) => {
        const selectOptions = await loadOptions(inputValue);

        callback(selectOptions);

        return selectOptions;
    };

    const handleChange: AsyncCreatableSelectProps<T>['onChange'] = (newValue) => {
        onChange(newValue || undefined);
    };

    return (
        <AsyncCreatableSelect
            defaultOptions
            className="flex-1"
            classNames={innerComponentsClassNames}
            isMulti={multi}
            isClearable={clearable}
            isSearchable={searchable}
            isDisabled={disabled}
            backspaceRemovesValue={backspaceRemoves}
            value={value}
            loadOptions={loadSelectOptions}
            onChange={handleChange}
            {...selectProps}
        />
    );
};

export default PolicyAsyncCreatableSelectField;
